<template>
    <div class="md-layout">
        <notifications></notifications>
        <!-- Listagem dos rankings -->
        <div class="md-layout-item md-size-100">
            <md-card v-if="!filterLoading">
                <md-card-header class="md-card-header-icon md-card-header-blue">
                    <div class="card-icon">
                        <md-icon>local_offer</md-icon>
                    </div>
                    <h4 class="title"></h4>
                </md-card-header>

                <md-card-content>
                    <md-table
                        :value="this.$store.state.stockRanking.totalItems"
                        :md-sort.sync="currentSort"
                        :md-sort-order.sync="currentSortOrder"
                        :md-sort-fn="orderByCustom"
                        class="paginated-table table-striped table-hover table-height"
                    >
                        <md-table-toolbar>
                            <div class="md-toolbar-section-start">
                                <h1 class="md-title">
                                    Ranking dos Produtos
                                </h1>
                                <LegendInfo
                                    bgColor="#98FF98"
                                    color="#3c653c"
                                    description="Aprovado Automaticamente"
                                />
                                <LegendInfo
                                    bgColor="#8585FF"
                                    color="#5656a4"
                                    description="Reposição Dinâmica Ativa"
                                />
                                <md-button
                                    class="md-just-icon md-simple"
                                    @click.native="handleColumnsEdit()"
                                >
                                    <md-icon>settings</md-icon>
                                </md-button>
                            </div>
                        </md-table-toolbar>
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                            <md-table-cell
                                v-for="column in visibleColumns"
                                :md-label="columnNames[column]"
                                :md-sort-by="column"
                                :key="column"
                                :title="item[column]"
                                v-bind:style="setRowColor(item)"
                            >
                                <div v-if="column === 'icons'">
                                    <v-icon
                                        v-if="item['is_guaranteed_stock']"
                                        title="Garantido"
                                        style="color:var(--red-400)"
                                    >
                                        mdi-lock
                                    </v-icon>
                                    <v-icon
                                        v-if="item['is_favorite']"
                                        title="Favorito"
                                        style="color:var(--yellow-400)"
                                    >
                                        mdi-star
                                    </v-icon>
                                    <span
                                        v-if="item['is_new']"
                                        title="Novo"
                                        class="new_product"
                                    >
                                        <img
                                            class="img_new_product"
                                            src="/img/new-product.png"
                                            alt="Novo Produto"
                                            title="Novo Produto"
                                        />
                                    </span>
                                </div>

                                <div v-if="column === 'is_selected'">
                                    <md-checkbox
                                        v-model="item['is_selected']"
                                        @change="restockingChange($event, item)"
                                        v-bind:disabled="disableCheckBox(item)"
                                    ></md-checkbox>
                                </div>
                                <div v-else>
                                    {{ setColumnCell(column, item) }}
                                </div>
                            </md-table-cell>
                        </md-table-row>
                    </md-table>
                </md-card-content>
                <md-card-actions md-alignment="space-between">
                    <div class="">
                        <p class="card-category">
                            Mostrando
                            {{
                                this.$store.state.stockRanking.totalItems.length
                            }}
                            itens de um total de {{ total }}.
                        </p>
                        <p class="card-category">
                            Selecionado {{ items_selected }} de um total de
                            {{ max_total_selected }}
                        </p>
                    </div>
                    <div class="">
                        <md-button
                            @click="applyChanges()"
                            class="md-primary"
                            type="submit"
                            :disabled="savePress"
                        >
                            Salvar
                        </md-button>
                    </div>
                </md-card-actions>
            </md-card>
            <md-card v-else>
                <md-card-content>
                    <div class="text-center mt-2 pb-2 ">
                        <img
                            src="loader.svg"
                            style="width: 100px; height: 100px"
                        />
                    </div>
                </md-card-content>
            </md-card>
        </div>

        <modal v-if="columnsModal" @close="columnsCancel()" width="250px">
            <template slot="header">
                <h4 class="modal-title">Colunas disponíveis</h4>
                <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="columnsCancel()"
                >
                    <md-icon>clear</md-icon>
                </md-button>
            </template>

            <template slot="body">
                <div style="text-align: left">
                    <md-checkbox
                        v-for="column in Object.keys(showColumns)"
                        v-model="showColumns[column]"
                        :key="column"
                    >
                        {{ columnNames[column] }}
                    </md-checkbox>
                </div>
            </template>

            <template slot="footer">
                <md-button class="md-primary" @click="columnsCancel()">
                    OK
                </md-button>
            </template>
        </modal>
    </div>
</template>

<script>
import Vue from 'vue'
import { Ranking as Model } from '@/models/ranking.model'

import { Modal } from '@/components'
import { mapActions, mapGetters } from 'vuex'
import axios from 'axios'
import Notifications from '@/components/NotificationPlugin'
import { solicitationTypes } from '@/services/constants/index.js'
import CustomSort from '@/mixins/CustomSort.vue'
import LegendInfo from '@/components/Legend/LegendInfo'

Vue.use(Notifications)

export default {
    async created() {
        const amplitude = this.$route.params.amplitude
        const token = this.$route.query.token

        //TODO: extrair para uma auth.model e auth.service ou utils
        await this.generateToken({ token })

        if (isNaN(Number(amplitude)) || !token) {
            this.$router.push('/')
            return
        }

        //TODO: extrair para uma ranking.module e ranking.service
        try {
            this.filterLoading = true
            const response = await axios.get(
                `/v1/restocking/rank-agg/${amplitude}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            )

            this.$store.state.stockRanking.totalItems = response.data.map(
                (item, index) => ({
                    ranking_position: index + 1,
                    ...item
                })
            )
            this.$store.state.stockRanking.totalItems.forEach(i => {
                if (i.is_selected) {
                    this.$store.state.stockRanking.itemIsSelectedInBack.push(
                        Object.assign({ frontIsSelected: true }, i)
                    )
                    this.selectedItems.push(i)
                } else {
                    this.$store.state.stockRanking.itemsNotSelectedInBack.push(
                        i
                    )
                }
            })

            this.orderByCustom(this.$store.state.stockRanking.totalItems)
            this.filterLoading = false
        } catch {
            this.$router.push('/')
        }
    },

    components: {
        Modal,
        LegendInfo
    },

    computed: {
        ...mapGetters({
            _getTotalItems: 'stockRanking/getTotalItems',
            _getItemIsSelectedInBack: 'stockRanking/getItemIsSelectedInBack',
            _getItemUnSelected: 'stockRanking/getItemUnSelected',
            _getItemSelected: 'stockRanking/getItemSelected'
        }),
        //TODO: Extrar para uma utils e reutilizar em todos os components
        visibleColumns() {
            let columns = []
            Object.keys(this.showColumns).forEach(key => {
                if (this.showColumns[key]) columns.push(key)
            })
            return columns
        },

        to() {
            if (this.$store.state.stockRanking.totalItems.length > 0)
                return this.$store.state.stockRanking.totalItems[
                this.$store.state.stockRanking.totalItems.length - 1
                    ].id
            else return 0
        },

        from() {
            if (this.$store.state.stockRanking.totalItems.length > 0)
                return this.$store.state.stockRanking.totalItems[0].id
            else return 0
        },

        items_selected() {
            let items_selected = 0
            if (this.$store.state.stockRanking.totalItems) {
                this.$store.state.stockRanking.totalItems.forEach(element => {
                    if (element.is_selected) {
                        items_selected++
                    }
                })
            }
            return items_selected
        },

        max_total_selected() {
            let max_total_selected = 0
            if (this.$store.state.stockRanking.totalItems[0]) {
                max_total_selected = this.$store.state.stockRanking
                    .totalItems[0].max_select
            }

            return max_total_selected
        },

        total() {
            return this.$store.state.stockRanking.totalItems.length
        }
    },

    data() {
        return {
            mixinTypeSort: 'asc',
            showColumns: Model.visibleFields,
            currentSort: 'ranking_position',
            currentSortOrder: 'asc',
            columnNames: Model.fieldNames,
            columnsModal: false,
            selectedItems: [],
            filterLoading: false,
            savePress: false
        }
    },
    mixins: [CustomSort],
    methods: {
        ...mapActions('ranking', {
            _createSolicitation: 'createSolicitation'
        }),
        ...mapActions('stockRanking', {
            _itemUnselected: 'itemUnselected',
            _itemSelected: 'itemSelected',
            _removeItem: 'removeItem'
        }),
        ...mapActions('auth', {
            _generateToken: 'generateToken'
        }),

        async generateToken({ token }) {
            await this._generateToken({ token })
        },
        handleColumnsEdit() {
            this.columnsModal = true
        },

        columnsCancel() {
            this.columnsModal = false
        },

        setColumnCell(column, item) {
            return column === 'product'
                ? item[column].name
                : column === 'id'
                    ? item['product'].external_id
                    : item[column]
        },

        restockingChange(event, item) {
            this.$nextTick(() => {
                if (item.is_selected) {
                    this.selectedItems.push(item)
                    this._itemSelected(item)
                } else {
                    this.selectedItems = this.selectedItems.filter(
                        i => i.product.id !== item.product.id
                    )
                    this._itemUnselected(this.selectedItems)
                    this._removeItem(item)
                }
            })
        },

        newProduct(afterColumn, item) {
            return afterColumn === 'ranking_position' && item['is_new'] === true
        },
        unSelected() {
        },
        setRowColor(item) {
            return item['is_selected']
                ? { background: '#8585FF', color: '#fff' }
                : item['auto_approved']
                    ? { background: '#98FF98' }
                    : ''
        },

        disableCheckBox(item) {
            return (
                item['is_stock_reserve'] ||
                (this.selectedItems.length >= this.max_total_selected &&
                    this.selectedItems.findIndex(
                        i => i.product.id === item['product'].id
                    ) === -1)
            )
        },
        async applyChanges() {
            this.filterLoading = true
            let editError
            let request_body = []
            let user = parseInt(localStorage.user_id)
            let amplitude = this.$route.params.amplitude
            this.savePress = true

            //--> TODO, pode fazer um merge dos dois arrays. Antes validar com Flávio
            this._getItemIsSelectedInBack.find(item => {
                item.solicitation_type =
                    solicitationTypes.TYPE_ADD_PRODUCT_MANAGER_PK
                request_body.push(item)
            })

            this._getItemSelected.find(item => {
                item.solicitation_type =
                    solicitationTypes.TYPE_ADD_PRODUCT_MANAGER_PK
                request_body.push(item)
            })
            //<-- TODO

            this._getItemUnSelected.find(item => {
                item.solicitation_type =
                    solicitationTypes.TYPE_REMOVE_PRODUCT_PK
                request_body.push(item)
            })

            if (request_body.length > 0) {
                editError = await this._createSolicitation({
                    user: user,
                    amplitude: amplitude,
                    request_body: request_body,
                    branch: request_body[0].branch_id
                })
            }

            this.filterLoading = false

            if (editError) {
                this.$notify({
                    message: 'Erro ao editar os parametros.',
                    icon: 'add_alert',
                    horizontalAlign: 'right',
                    verticalAlign: 'bottom',
                    type: 'danger'
                })

                this.savePress = false
            } else {
                this.$notify({
                    message:
                        'Alteração realizada com sucesso, você pode fechar essa tela.',
                    icon: 'add_alert',
                    horizontalAlign: 'right',
                    verticalAlign: 'bottom',
                    type: 'success'
                })
            }
        }
    }
}
</script>

<style lang="css" scoped>
.modal-wrapper .md-checkbox {
    display: flex !important;
}

.table-height {
    max-height: 70vh;
}

.md-table-row {
    text-align: center;
}

.new_product {
    position: absolute;
    animation: animateProduct 2s linear infinite;
    overflow: hidden;
    top: 1px;
    right: 2px;
}
</style>
